@if (isLoading) {
  <mat-spinner></mat-spinner>
}

<h2 class="section-title">
  {{ title() }}
</h2>

<div class="excel-form">
  @if (enabledControls().date) {
    <mat-form-field appearance="fill" color="accent" (click)="picker1.open()">
      <mat-label>{{ 'ADMIN.DAYS_LEFT.SELECT_DATE' | translate }}</mat-label>
      <input
        [formControl]="dateControl"
        matInput
        [matDatepicker]="picker1"
        [max]="maxDate"
        [min]="minDate"
      />
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1 color="primary"></mat-datepicker>
    </mat-form-field>
  }

  @if (enabledControls().dateRangeToggle) {
    <div class="export-mode-toggle">
      <label>{{ 'ADMIN.CLIENT_HOURS.EXPORT_MODE' | translate }}</label>
      <mat-radio-group
        color="primary"
        [value]="rangeMode()"
        (change)="onRangeModeChange($event.value)"
        [attr.aria-label]="'ADMIN.CLIENT_HOURS.EXPORT_MODE' | translate"
      >
        <mat-radio-button [value]="false">{{ 'ADMIN.CLIENT_HOURS.BY_MONTH' | translate }}</mat-radio-button>
        <mat-radio-button [value]="true">{{ 'ADMIN.CLIENT_HOURS.BY_DATE_RANGE' | translate }}</mat-radio-button>
      </mat-radio-group>
    </div>
  }

  @if (useMonth) {
    <app-month-field
      [formControl]="monthControl"
      [maxDate]="maxDateStartOfMonth"
      [minDate]="minDate"
      [label]="'ADMIN.CLIENT_HOURS.MONTH' | translate"
    ></app-month-field>
  }

  @if (useDateRange) {
    <div class="date-range-fields">
      <div class="date-range-pickers">
        <mat-form-field appearance="fill" color="accent" (click)="fromPicker.open()">
          <mat-label>{{ 'ADMIN.CLIENT_HOURS.FROM_DATE' | translate }}</mat-label>
          <input
            [formControl]="fromDateControl"
            matInput
            [matDatepicker]="fromPicker"
            [max]="maxDateRange"
            [min]="minDateRange"
          />
          <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
          <mat-datepicker #fromPicker color="primary"></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="fill" color="accent" (click)="toPicker.open()">
          <mat-label>{{ 'ADMIN.CLIENT_HOURS.TO_DATE' | translate }}</mat-label>
          <input
            [formControl]="toDateControl"
            matInput
            [matDatepicker]="toPicker"
            [max]="toDateMax"
            [min]="fromDateControl.value"
          />
          <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
          <mat-datepicker #toPicker color="primary"></mat-datepicker>
        </mat-form-field>
      </div>
      @if (isRangeCapped) {
        <mat-error class="date-range-error">{{ 'ADMIN.CLIENT_HOURS.DATE_RANGE_HINT' | translate }}</mat-error>
      }
    </div>
  }

  @if (enabledControls().project) {
    <mat-form-field appearance="fill" subscriptSizing="dynamic">
      <mat-label>{{ 'ADMIN.CLIENT_HOURS.PROJECTS' | translate }}</mat-label>
      <input
        type="text"
        matInput
        placeholder="{{ 'ADMIN.CLIENT_HOURS.PROJECTS' | translate }}"
        #filter
        [formControl]="projectControl"
        [matAutocomplete]="auto"
      />
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayProjectNameFn">
        @for (project of projectList() | filter: filter.value : 'name'; track project) {
          <mat-option [value]="project">
            {{ project.name }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  }

  @if (enabledControls().employee) {
    <app-employee-search
      (clear)="onEmployeeSelect(null)"
      (onselect)="onEmployeeSelect($event)"
    ></app-employee-search>
  }

  <button
    (click)="submit()"
    mat-raised-button
    color="primary"
    type="button"
    class="excel-button"
    [disabled]="isSubmitDisabled"
  >
    <mat-icon>download</mat-icon>
    {{ 'ADMIN.CLIENT_HOURS.EXPORT' | translate }}
  </button>
</div>
